type Item<T> = T & { id: string | null }

export const dedupe = <T>(nodes: Item<T>[]) => {
  return nodes.filter((item1, i, items) => items.findIndex(item2 => item2.id == item1.id) === i)
}
